import { ICON_PATH } from '@federa/const/icon-svg-paths';
import { createIcon } from '../createIcon.tsx';

export const BellIcon = createIcon(
	'BellIcon',
	<>
		<path d={ICON_PATH.BELL_BODY} />
		<path d={ICON_PATH.BELL_CLAPPER} />
	</>,
);
